import styled, { css, keyframes } from "styled-components";

const shimmer = keyframes`
  from { background-position: 150% 0; }
  to { background-position: -50% 0; }
`;

// Kept invisible for the first 150ms, so a fast response never flashes it.
const appear = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fill = (base, shine) => css`
  background: ${base} linear-gradient(90deg, ${base} 30%, ${shine} 50%, ${base} 70%);
  background-size: 300% 100%;
  animation: ${appear} 0.2s ease-out 0.15s both,
    ${shimmer} 1.4s ease-in-out infinite;
  @media (prefers-reduced-motion: reduce) {
    animation: ${appear} 0.2s ease-out 0.15s both;
  }
`;

// One grey (or translucent white, over the blue header) block of the size given.
export const Bone = styled.div`
  width: ${(p) => p.w || "100%"};
  max-width: 100%;
  height: ${(p) => p.h || "16px"};
  margin-top: ${(p) => p.mt || 0};
  margin-bottom: ${(p) => p.mb || 0};
  border-radius: 4px;
  ${(p) =>
    p.dark
      ? fill("rgba(255, 255, 255, 0.16)", "rgba(255, 255, 255, 0.32)")
      : fill("#e6ecf8", "#f4f7fd")}
`;

// Same box as the navbar logo (80px tall, 32px on mobile).
export const LogoBone = styled(Bone)`
  width: 120px;
  height: 80px;
  @media (max-width: 768px) {
    width: 48px;
    height: 32px;
  }
`;

// Sits where a menu label would, inside the item's 25px row and 18px padding.
export const NavItemBone = styled(Bone)`
  margin: 6px 18px 0;
`;

export const HeroTitleBones = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  padding-right: 40px;
  @media (max-width: 768px) {
    gap: 8px;
    padding-right: 0;
    & > * {
      max-width: 110px;
      height: 14px;
    }
    & > :last-child {
      height: 26px;
    }
  }
`;

// The hero image is 1000px wide on desktop, 100% of its column on mobile.
export const HeroImageBone = styled(Bone)`
  width: 1000px;
  height: auto;
  aspect-ratio: 16 / 9;
  border-radius: 0;
  ${fill("#dbe3f5", "#eef2fb")}
  @media (max-width: 768px) {
    width: 100%;
  }
  /* Full-screen hero: fill the stretched image column. */
  .header--full & {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    aspect-ratio: auto;
  }
`;

export const Section = styled.div`
  padding-bottom: 120px;
  @media (max-width: 768px) {
    padding-bottom: 54px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 30px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
  }
`;

export const CardImageBone = styled(Bone)`
  height: auto;
  aspect-ratio: 16 / 10;
  border-radius: 0;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
`;
